/* ezb-slider — generic prev/next driver for [EZ] Builder scroll-snap tracks
   (used by [EZB] Timeline, and later [EZB] Row Slider). Container carries [data-ezb-slider],
   the scrollable track [data-ezb-track], and optional [data-ezb-prev]/[data-ezb-next] buttons.
   Idempotent: safe to run multiple times / on shopify:section:load. */
(function () {
  function step(track) {
    var item = track.children[0];
    var s = getComputedStyle(track);
    var gap = parseFloat(s.columnGap || s.gap || '0') || 0;
    if (!item) return track.clientWidth * 0.8;
    return item.getBoundingClientRect().width + gap;
  }
  function update(root, track, prev, next) {
    var max = track.scrollWidth - track.clientWidth - 2;
    // disable (not hide) at the ends so both arrows stay visible side by side
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function init(root) {
    if (root.dataset.ezbSliderReady === '1') return;
    var track = root.querySelector('[data-ezb-track]');
    if (!track) return;
    root.dataset.ezbSliderReady = '1';
    var prev = root.querySelector('[data-ezb-prev]');
    var next = root.querySelector('[data-ezb-next]');
    // hide the arrows entirely when there's nothing to page through (opt-in via [data-ezb-hide-single])
    if (root.hasAttribute('data-ezb-hide-single') && track.children.length <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { update(root, track, prev, next); }, { passive: true });
    window.addEventListener('resize', function () { update(root, track, prev, next); });
    update(root, track, prev, next);
  }
  function boot() {
    var nodes = document.querySelectorAll('[data-ezb-slider]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
